import MuiCard from '@mui/material/Card';
import MuiCardContent from '@mui/material/CardContent';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

const PREFIX = 'DescriptionCard';

const classes = {
  cardMui: `${PREFIX}-cardMui`,
  details: `${PREFIX}-details`,
  descriptionTitle: `${PREFIX}-descriptionTitle`,
  contentText: `${PREFIX}-contentText`
};

const StyledMuiCard = styled(MuiCard)(({ theme }) => ({
  [`&.${classes.cardMui}`]: {
    display: 'flex',
    height: '280px'
  },

  [`& .${classes.details}`]: {
    position: 'relative',
    width: '100%',
    padding: theme.spacing(1)
  },

  [`& .${classes.descriptionTitle}`]: {
    color: theme.palette.text.primary
  },

  [`& .${classes.contentText}`]: {
    color: theme.palette.text.primary,
    whiteSpace: 'pre-line'
  }
}));

export interface DescriptionCardItem {
  title?: string;
  contentText?: string;
}

export default function DescriptionCard({
  title = 'Description',
  contentText
}: DescriptionCardItem) {
  return (
    <StyledMuiCard raised className={classes.cardMui}>
      <div className={classes.details} data-testid="KPIDescriptionCard-content">
        <MuiCardContent>
          <Typography variant="h5" className={classes.descriptionTitle}>
            {title}
          </Typography>
          <Typography variant="body2" className={classes.contentText}>
            {'\n'}
            {contentText}
          </Typography>
        </MuiCardContent>
      </div>
    </StyledMuiCard>
  );
}
